import React from 'react';
import ServiceCategoryPage from './ServiceCategoryPage';

const SicknessLetters = () => {
  return (
    <ServiceCategoryPage
      category="Sickness Letters"
      title="Sickness Letters"
      intro="Get a same-day, verifiable medical certificate or sick note from a UK-registered doctor for work, university, or school. Fast, simple, and confidential."
    />
  );
};

export default SicknessLetters;